// FakeNavigation.tsx
import React, { useState } from "react";
import "./FakeNav.css"; // Подключаем стили

const FakeNavigation: React.FC = () => {
  const [isCoursesOpen, setIsCoursesOpen] = useState(false);
  const [isTestingOpen, setIsTestingOpen] = useState(false);

  const toggleCourses = () => setIsCoursesOpen(!isCoursesOpen);
  const toggleTesting = () => setIsTestingOpen(!isTestingOpen);

  return (
    <div className="fake-navigation">
      <div className="fakenav-title">Навигация:</div>
      <ul>
        <li>В начало</li>
        <li>Личный кабинет</li>
        <li>Страницы сайта</li>
        <li>
          <span onClick={toggleCourses} className="toggle-btn">
            {isCoursesOpen ? "- Мои курсы" : "+ Мои курсы"}
          </span>
          {isCoursesOpen && (
            <ul>
              <li>
                <span onClick={toggleTesting} className="toggle-btn">
                  {isTestingOpen
                    ? "- Тестирование - 1 -й этап"
                    : "+ Тестирование - 1 -й этап"}
                </span>
                {isTestingOpen && (
                  <ul>
                    <li>Участники</li>
                    <li>Компетенции</li>
                  </ul>
                )}
              </li>
            </ul>
          )}
        </li>
      </ul>
    </div>
  );
};

export default FakeNavigation;
